/**
 * Splits a same-origin redirect target — a path, optionally carrying its own
 * query string (e.g. "/provider-invite?token=abc123") — into TanStack
 * Router's `to` + `search` navigate shape.
 *
 * The sign-in routes' `redirect` search param has only ever carried a bare
 * pathname (see `_provider.tsx`'s `redirect: location.pathname`). TanStack
 * Router's `navigate({ to })` does not parse a literal "?" embedded in `to` —
 * it treats the whole string as a path segment — so a return-to target that
 * needs its own query string (like the provider-invite acceptance page's
 * token) must be split apart here and passed back as `search` explicitly.
 */
export function parseRedirectTarget(redirect: string): {
  to: string;
  search: Record<string, string> | undefined;
} {
  const url = new URL(redirect, window.location.origin);
  const search = Object.fromEntries(url.searchParams);

  return {
    to: url.pathname,
    search: Object.keys(search).length > 0 ? search : undefined,
  };
}
